import React, { useEffect, useState } from "react";
import { Modal, Button, Badge } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  WarningOutlined,
  ClockCircleOutlined,
  StarOutlined,
  StarFilled,
} from "@ant-design/icons";
import { CheckCircleOutlined } from "@ant-design/icons";
import useNuJobsStore from "../../../store/nujobsevals.store";
import "./nujobsDashboardEvalCard.scss";

// import "./qsetdashboardevalcard.scss";

function NuJobsDashboardEvalCard({
  evalItem,
  questionsArray,
  setFavouriteEvals,
  favouriteEvals,
  setTotalFavouriteEvals,
}) {
  const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(false);
  const {
    allGlobalEvals,
    getAllGlobalEvals,
    getQuestionsForEvaluation,
    getMyEvals,
    myEvals,
    getFavouriteEvals,
    myFavouriteEvals,
    addFavouriteEval,
    deleteFavouriteEval,
  } = useNuJobsStore();

  const handleToggle = (e) => {
    e.stopPropagation(); // Prevents triggering parent click events (like card clicks)
    setFavouriteEvals((prev) => {
      const updatedFavourites = [...prev];
      const index = updatedFavourites.findIndex(
        (item) => item === evalItem.qhevid,
      );
      //console.log(index, "Index of evalItem in favourites");
      if (index !== -1) {
        updatedFavourites.splice(index, 1);
        deleteFavouriteEval(evalItem.qhevid); // Call the function to remove from favorites
      } else {
        updatedFavourites.push(evalItem.qhevid);
        addFavouriteEval(evalItem.qhevid);
      }
      setTotalFavouriteEvals(updatedFavourites.length); // Update the total count
      //console.log(updatedFavourites);
      return updatedFavourites;
    });
    setIsFavorite(!isFavorite);
  };

  const handleTsToDate = (value) => {
    const eDay = new Date(value * 1000);
    return eDay.toDateString();
  };
  const handleTsToTime = (value) => {
    const eDay = new Date(value * 1000);
    return eDay.toLocaleTimeString();
  };
  const handleOnClick = () => {
    navigate(`/qsethome/qsetjd`);
  };

  const handleStartTest = () => {
    var ev_id = evalItem.qhevid;
    navigate(`/nujobshome/nujobsEvaluations/readyPage/${ev_id}`);
  };

  const EvalStatus = {
    Pending: (
      <>
        <Button
          className="apply-button"
          disabled={evalItem?.evalstatus === "Completed"}
          onClick={handleStartTest}
        >
          Start Test
        </Button>
        <span className="company-name">
          <span className="eval-detail-item eval-expires">Created On:</span>
          <span className="eval-detail-item eval-expires">
            {evalItem?.createdby.updatedon}
          </span>
        </span>
      </>
    ),
    "Proctoring Fail": (
      <>
        <div className="result-info-warning">
          <span className="info-warning">
            <WarningOutlined />
          </span>{" "}
          Proctoring terminated after repeated violations.
        </div>
        <p className="contact-info">Please contact HR for more information.</p>
      </>
    ),

    Completed: (
      <>
        <div className="result-info-completed">
          <span className="info-completed">
            <CheckCircleOutlined />
          </span>{" "}
          Awaiting Results... HR will get back to you for next steps
        </div>
        {/* <p className="contact-info">HR will contact you soon.</p> */}
      </>
    ),
  };

  const getLevelColor = (level) => {
    switch (level?.toLowerCase()) {
      case "beginner":
        return "green";
      case "intermediate":
        return "blue";
      case "advanced":
        return "orange";
      case "expert":
        return "red";
      default:
        return "purple";
    }
  };

  const levelText = evalItem?.generalsetting?.level || "Beginner";

  return (
    <Badge.Ribbon
      text={levelText}
      color={getLevelColor(levelText)}
      placement="end" // "start" puts it on the top-left, leaving the top-right clear for your heart icon
      styles={{
        indicator: {
          top: "25px", // Pushes the ribbon 10px down from the top edge
        },
      }}
    >
      <div className="nujobsEval-card">
        <div className="nujobsEval-card-header">
          <div className="nujobsEval-title">
            {evalItem?.generalsetting.name}
          </div>
        </div>
        <div className="nujobsEval-duration">
          <div className="nujobsEval-duration-title">
            <ClockCircleOutlined /> {evalItem?.generalsetting.duration} mins
          </div>
          <div
            className={`nujobsEval-title1 ${favouriteEvals.includes(evalItem?.qhevid) ? "is-favorite" : ""}`}
            onClick={handleToggle}
          >
            {favouriteEvals.includes(evalItem?.qhevid) ? (
              <StarFilled />
            ) : (
              <StarOutlined />
            )}
          </div>
        </div>
        <div className="nujobsEval-details">
          {evalItem?.skillarray?.map((skillItem, idx) => (
            <span className="eval-detail-item eval-skill">
              {skillItem.skill.toUpperCase()}
            </span>
          ))}
        </div>

        {EvalStatus[evalItem?.evalstatus ? evalItem?.evalstatus : "Pending"]}
      </div>
    </Badge.Ribbon>
  );
}

export default NuJobsDashboardEvalCard;
